import TomSelect from 'tom-select';

export default class getInitPlayers{

    /**
     * Get Players
     * @returns 
     */
    getPlayers(el_players: string){
        
        const control = new TomSelect(el_players, {
            plugins: ['dropdown_input'],
            allowEmptyOption: true,
            persist: false,
            valueField:'id',
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">'+ escape(item.text) +'</span>';
                },
                item: function (item, escape) {
                    return '<span>'+ escape(item.text) +'</span>';
                },
            }
        });

        control.disable();

        return control;

    }

    /**
     * Set players
     * @param control 
     * @param players 
     */
    setPlayers(control: any, players: number, date: string, minPlayersWeekday: number, minPlayersWeekend: number){
        
        control.enable();
        control.clear();
        control.clearOptions();

        const dayOfWeek = new Date(date).getDay(); // 0 = Domenica, ..., 6 = Sabato
        const minPlayers = (dayOfWeek >= 1 && dayOfWeek <= 5) ? minPlayersWeekday : minPlayersWeekend;

        let options: { [key: string]: { id: string, text: string } } = {};

        for(let i = minPlayers; i <= players; i++){
            
            options[i.toString()] = { id: i.toString(), text: i.toString() };

        }

        control.addOptions(options, false);

        const firstValue = Object.keys(control.options)[0];

        if(firstValue){
            
            control.setValue(firstValue);

        }

    }

}